import { put, takeLatest } from 'redux-saga/effects';
import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import categoryServices from './services';
import categoryActions from './actions';
import categoryTypes from './types';

function* getActiveCategories(action) {
	try {
		let response = yield sagaCallService(
			categoryServices.actives,
			action,
			action.payload
		);
		yield put(categoryActions.activesSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, categoryActions.activesFailure);
	}
}

function* getSubcategories(action) {
	try {
		let response = yield sagaCallService(
			categoryServices.subCategories,
			action,
			action.payload
		);
		yield put(categoryActions.subCategoriesSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, categoryActions.subCategoriesFailure);
	}
}

function* getDynamicAttributes(action) {
	try {
		let response = yield sagaCallService(
			categoryServices.dynamcAttributes,
			action,
			action.payload
		);
		yield put(categoryActions.dynamicAttributesSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			categoryActions.dynamicAttributesFailure
		);
	}
}

function* getCategoriesTags(action) {
	try {
		let response = yield sagaCallService(
			categoryServices.tags,
			action,
			action.payload
		);
		yield put(categoryActions.tagsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, categoryActions.tagsFailure);
	}
}

function* getCategoryRecoomonded(action) {
	try {
		let response = yield sagaCallService(
			categoryServices.recommendedCategories,
			action,
			action.payload
		);
		yield put(categoryActions.recommendedSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, categoryActions.recommendedFailure);
	}
}

const categorySagas = [
	takeLatest(categoryTypes.ACTIVES.REQUEST, getActiveCategories),
	takeLatest(categoryTypes.SUB_CATEGORIES.REQUEST, getSubcategories),
	takeLatest(categoryTypes.DYNAMIC_ATTRIBUTES.REQUEST, getDynamicAttributes),
	takeLatest(categoryTypes.TAGS.REQUEST, getCategoriesTags),
	takeLatest(categoryTypes.RECOMMONED.REQUEST, getCategoryRecoomonded),
];

export default categorySagas;
